import { BaseService } from "@flint/framework";

export default class EPubDeleteData extends BaseService {
  constructor() {
    super("FEATURING_EPUB_BOOK","EPubFeatureResStore",true);
  }

  handleEvent = (eventName, ePub) => {
    return this.getClient("vetService").put(`/admin-api/epubs/footer-books`, null , {
      params: {
        "isbn": ePub.isbn,
        "isDisplay": ePub.isDisplay
      },
    })
  };
}
